import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemArrowBack = function IconSystemArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 12H4m0 0 6 6m-6-6 6-6"
  }));
};